module.exports = __webpack_public_path__ + "static/img/2d1b12f6db56a8c30a67c8dc18d3ff9d@2x.79127bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/2d1b12f6db56a8c30a67c8dc18d3ff9d@2x.png
// module id = Z0eW
// module chunks = 1